import { render } from "./DirectusCall.vue?vue&type=template&id=018df64c"
import script from "./DirectusCall.vue?vue&type=script&lang=js"
export * from "./DirectusCall.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konradmilewski/Projects/AppWorks/janpawelvue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__